import './textShimmer.css';

import React from 'react';

/**
 * Shimmering single-line text. Typography and color are inherited from the
 * container; the base text and its highlighted copy are laid out identically,
 * so both truncate at the same point.
 */
export function ActiveShimmerText({text}: {text: string}) {
  return (
    <span className="wbagent-row-shimmer">
      {text}
      <span aria-hidden="true" className="wbagent-shimmer-window">
        <span className="wbagent-shimmer-text">{text}</span>
      </span>
    </span>
  );
}

type ShimmerTextProps = {
  text: string;
  isActive: boolean;
  /** Rendered instead of `text` while inactive. */
  children?: React.ReactNode;
};

export function ShimmerText({text, isActive, children}: ShimmerTextProps) {
  if (isActive && text.length > 0) {
    return <ActiveShimmerText text={text} />;
  }
  return <>{children ?? text}</>;
}
